import { computed, inject, Injectable, resource } from '@angular/core';
import { SimpleApi } from '@core/api/simple.api';
import { ProduktType } from '@features/letregister/produkt-type.model';
import dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class ProduktTypeService {
  simpleApi = inject(SimpleApi);

  produktTyper = resource({
    loader: async ({ abortSignal }) => {
      const aar = dayjs().get('year');
      return await this.simpleApi.getList<ProduktType>(
        '/api/admin/produktlister/produkttyper',
        {
          aar: aar,
        },
        abortSignal
      );
    },
  });

  produktTypeOptions = computed(() => {
    const data = this.produktTyper.value() || [];
    const values = data
      .sort((a, b) => (a.produktTypeNummer > b.produktTypeNummer ? 1 : -1))
      .map(x => x.produktTypeNummer);
    const distinctValues = [...new Set(values)];
    return distinctValues;
  });

  produktTypeMedNavnOptions = computed(() => {
    const distinctValues = this.produktTypeOptions();
    const data = this.produktTyper.value() || [];
    return distinctValues.map(produktTypeNummer => {
      const navn = data.find(
        y => y.produktTypeNummer === produktTypeNummer
      )?.navn;
      return {
        value: produktTypeNummer,
        text: produktTypeNummer + ' - ' + navn,
      };
    });
  });
}
